goog.module('yext.developerapps.tableauconnector.ConfigureSchema');
goog.module.declareLegacyNamespace();

class ConfigureSchema {
  constructor(ajaxActions) {
    this.ajaxActions = ajaxActions;
    this.schema = ajaxActions.getSchemaJson();

    this.CUSTOM_FIELD_TYPE_LOOKUP = {
      'BOOLEAN': tableau.dataTypeEnum.bool,
      'DATE': tableau.dataTypeEnum.date,
      'MULTILINE_TEXT': tableau.dataTypeEnum.string,
      'TEXT': tableau.dataTypeEnum.string,
      'NUMBER': tableau.dataTypeEnum.string,
      'URL': tableau.dataTypeEnum.string,
    };

    this.buildTables = this.buildTables.bind(this);
    this.getEntitiesTable = this.getEntitiesTable.bind(this);
    this.appendCustomFields = this.appendCustomFields.bind(this);
    this.getTable = this.getTable.bind(this);
    this.getTableFields = this.getTableFields.bind(this);
    this.getTables = this.getTables.bind(this);

    this.buildTables();
  }

  buildTables() {
    console.log('Building table schema..');
    var tables = {};
    var tableList = this.schema['tables'];
    for (var t in tableList) {
      tables[tableList[t]['id']] = tableList[t];
    }
    console.log('schema tables parsed: ' + JSON.stringify(Object.keys(tables)));
    this.tables = tables;
  }

  getTable(id) {
    return this.tables[id];
  }

  getTableFields(id) {
    return this.tables[id]['columns'];
  }

  getEntitiesTable() {
    var entitiesTable = this.getTable(ConfigureSchema.Table.ENTITIES);
    var fieldList = entitiesTable['columns'];
    this.appendCustomFields(fieldList);
    return entitiesTable;
  }

  appendCustomFields(entityFields) {
    var customFields = this.ajaxActions.getCustomFields();
    for (var cField in customFields) {
      var newField = {
        'id': customFields[cField].id,
        'alias': customFields[cField].name,
        'yextId': customFields[cField].id,
        'dataType': this.CUSTOM_FIELD_TYPE_LOOKUP[customFields[cField].type],
      };
      entityFields.push(newField);
    }
  }

  getTables(selectedTables) {
    var allTables = [];

    allTables.push(this.getEntitiesTable());

    for (var table in selectedTables) {
      allTables.push(this.getTable(selectedTables[table]));
      console.log('selectedTable, ID found: ' + selectedTables[table]);
    }

    return allTables;
  }

  getTableTypes() {
    return ConfigureSchema.Table;
  }
}

ConfigureSchema.Table = {
  METRICS: 'metrics',
  BING_SEARCHES: 'bing_searches',
  ENTITIES: 'entities',
  REVIEWS: 'reviews',
  SEARCH: 'search',
  FACEBOOK_LISTINGS: 'facebook_listings',
  GOOGLE_LISTINGS: 'google_listings',
  NEW_GOOGLE_LISTINGS: 'new_google_listings',
  GOOGLE_PHONE: 'google_phone',
  LISTINGS: 'listings',
  PAGES: 'pages',
  PROFILES: 'profiles',
  REVIEWS_ANALYTICS: 'reviews_analytics',
  SEARCHES: 'searches',
  SEARCHES_CLICKS: 'searches_clicks',
  SEARCH_CASE_DEFLECTION: 'search_case_deflection',
  GOOGLE_LISTING_ACTIONS: 'google_listing_actions',
  GOOGLE_SEARCH_KEYWORD_IMPRESSIONS: 'google_search_keyword_impressions',
  TOTAL_LISTINGS_IMPRESSIONS: 'total_listings_impressions',
  GOOGLE_CALLS_ANALYTICS: 'google_calls_analytics',
};

exports = ConfigureSchema;
